import { render } from "./TodoList.vue?vue&type=template&id=072c7806"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"
script.render = render

export default script